import { render, staticRenderFns } from "./DashboardServerAvailabilityItem.vue?vue&type=template&id=1381a1da"
import script from "./DashboardServerAvailabilityItem.vue?vue&type=script&lang=js"
export * from "./DashboardServerAvailabilityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports